<template>
  <v-tooltip max-width="400px" left class="absolute right-0 top-0">
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        class="absolute right-0"
        :class="icon_class"
        :color="icon_color"
        dark
        v-bind="attrs"
        v-on="on"
      >
        {{ icon }}
      </v-icon>
    </template>
    <span>{{ $t(`${text}`) }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "mdi-information-outline",
    },
    text: { type: String, default: "" },
    icon_class: { type: String, default: "" },
    icon_color: {
      type: String,
      default: "primary"
    }
  },
};
</script>

<style>
</style>